import _classNames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icons/Icon/Icon';

/**
  An inline alert.
*/
class Callout extends React.Component {
  static TYPE = {
    DEFAULT: 'default',
    ACTIVE: 'active',
    SUCCESS: 'success',
    INFORMATIONAL: 'informational',
    WARNING: 'warning',
    ERROR: 'error',
  };

  static THEME = {
    BLACK: 'black',
    COLOR: 'color',
  };

  static SIZE = {
    NORMAL: 'normal',
    LARGE: 'large',
  };

  static TYPE_TO_ICON_MAP = {
    [Callout.TYPE.DEFAULT]: 'User',
    [Callout.TYPE.ACTIVE]: 'SIM',
    [Callout.TYPE.SUCCESS]: 'Circle--check',
    [Callout.TYPE.INFORMATIONAL]: 'Circle--info',
    [Callout.TYPE.WARNING]: 'Warning',
    [Callout.TYPE.ERROR]: 'Circle--alert',
  };

  render() {
    const { text, type, size, iconLeft, iconColor, defaultIcon, rightElement, className } =
      this.props;
    const defaultIconForType = defaultIcon && Callout.TYPE_TO_ICON_MAP[type];
    const icon = defaultIconForType || iconLeft;

    return (
      <div
        className={_classNames(
          'Callout',
          `Callout--type-${type || Callout.TYPE.DEFAULT}`,
          `Callout--size-${size || Callout.SIZE.NORMAL}`,
          className
        )}
      >
        <div className="Callout__container">
          {icon && (
            <Icon
              classes={_classNames('Callout__icon-left', {
                'Callout__icon-left--color': iconColor === Callout.THEME.COLOR,
              })}
              name={icon}
              size="minor"
            />
          )}
          <div className="Callout__text">{text}</div>
        </div>
        {rightElement && <div className="Callout__rightElement">{rightElement}</div>}
      </div>
    );
  }
}

Callout.propTypes = {
  /**
    The main callout text
  */
  text: PropTypes.string.isRequired,
  /**
    Type of the callout (affects color)
  */
  type: PropTypes.oneOf([
    Callout.TYPE.DEFAULT,
    Callout.TYPE.INFORMATIONAL,
    Callout.TYPE.WARNING,
    Callout.TYPE.ACTIVE,
    Callout.TYPE.SUCCESS,
    Callout.TYPE.ERROR,
  ]),
  /**
    Size of the callout (affects text size and spacing)
  */
  size: PropTypes.oneOf([Callout.SIZE.NORMAL, Callout.SIZE.LARGE]),
  /**
    CSS class to add
  */
  className: PropTypes.string,
  /**
    Optionally render an `Icon` to the left of the callout text, can be overridden by `defaultIcon` below
  */
  iconLeft: PropTypes.string,
  /**
    Optionally change color of the `Icon`
  */
  iconColor: PropTypes.oneOf([Callout.THEME.BLACK, Callout.THEME.COLOR]),
  /**
    Optionally use the default icon for the callout type; also note that this overrides `iconLeft` if both props are passed in
  */
  defaultIcon: PropTypes.bool,
  /**
    Optionally render an element to the right of the callout text
  */
  rightElement: PropTypes.node,
};

Callout.defaultProps = {
  type: undefined,
  size: undefined,
  className: undefined,
  iconLeft: undefined,
  iconColor: undefined,
  defaultIcon: undefined,
  rightElement: undefined,
};

/**
 * @type {any}
 */
export default Callout;
